import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	standalone: false,
	selector: 'bt-company-dashboard',
	templateUrl: './company-dashboard.component.html',
	styleUrls: ['./company-dashboard.component.scss']
})
export class CompanyDashboardComponent {
	constructor(private router: Router) {}

	onNavigateToOrders(): void {
		this.router.navigate(['/company/order-list']);
	}

	onNavigateToStyles(): void {
		this.router.navigate(['/company/style-list']);
	}
}
